import { useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import { VideoSlide, type VideoSlideData } from "~/components/common/VideoSlide";

interface FullscreenVideoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data?: VideoSlideData;
  // Watch-event surface tag identifying the page this modal was opened from.
  surface?: string;
}

export function FullscreenVideoModal({ open, onOpenChange, data, surface = "watch_modal" }: FullscreenVideoModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onOpenChange(false);
      }
    };

    if (open) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onOpenChange]);

  if (!open || !data) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      <button
        id="fullscreen-video-close"
        onClick={() => onOpenChange(false)}
        className="fixed top-4 left-4 z-50 flex size-10 items-center justify-center rounded-full bg-black/50 text-white backdrop-blur-sm hover:bg-black/70"
        aria-label="Close"
      >
        <ChevronLeft className="size-6" />
      </button>

      <div className="aspect-[9/16] h-auto w-[min(80vw,calc(80vh*9/16))] overflow-hidden rounded-lg">
        <VideoSlide data={data} trackWatch surface={surface} />
      </div>
    </div>
  );
}
